import { AutogenLayoutStatusErrorQuickInfo } from "./autogen/AutogenLayoutStatusErrorQuickInfo";

export class StatusErrorQuickInfo extends AutogenLayoutStatusErrorQuickInfo {

    sourceEdiMapErrorAfterExecution(){
        const mapErrorsCount = this.mainDataSource.data.length;
        if(mapErrorsCount === 1){
            //necessary to adjust spacing due to template errors being dispayed in separate component.  
            this.labelTemplateErrorTxt.marginTop = -10; 
        }
        
    }

}
